module.exports = __webpack_public_path__ + "static/media/call.08cfe6bd.svg";